import { Checkbox } from 'primereact/checkbox'
import { pathOr } from 'ramda'
import React from 'react'
import { setTimeSplitByDay } from '@medical/libs'
const CustomCheckBox = ({
  label,
  name,
  disabled,
  values,
  touched,
  errors,
  setFieldValue,
  options = [],
  optionLabel = 'description',
  valueLabel = 'value',
  required,
  getCurrentValue,
  onceCheck,
  breakLine,
  inLine,
  listWeekDay,
  listWeekDay1,
  listWeekDay2,
  listWeekDay3,
  listWeekDay4,
}) => {
  const isTouched = pathOr(false, [name], touched)
  const error = pathOr('', [name], errors)
  const jsUcfirst = string => {
    return 'is' + string.charAt(0).toUpperCase() + string.slice(1)
  }
  return (
    <div className='tr multiple-checkbox-container'>
      <div
        className={` ${breakLine ? 'reson-label_check' : ''} title-week-day ${
          required ? 'required' : ''
        }`}
      >
        {label}
      </div>
      <div className={`td ${inLine ? 'inline-row' : ''}`}>
        {options.map((option, i) => (
          <div
            className={`checkbox-container ${
              inLine ? 'inline-multiple-row_container margin-0' : ''
            }`}
            key={option[valueLabel]}
          >
            <Checkbox
              value={option[valueLabel]}
              disabled={disabled}
              onChange={e => {
                let selectedOptions =
                  name === 'doctorStatus' || onceCheck
                    ? [values[name]]
                    : [...values[name]]
                if (values[name].includes(e.value)) {
                  // selectedOptions.splice(selectedOptions.indexOf(e.value), 1)
                  selectedOptions = selectedOptions.filter(
                    item => item !== e.value
                  )
                } else {
                  if (name === 'doctorStatus') {
                    selectedOptions.length = 0
                    getCurrentValue(e.value)
                  }
                  if (onceCheck) {
                    selectedOptions.length = 0
                  }
                  selectedOptions.push(e.value)
                }
                setFieldValue(jsUcfirst(e.value), e.target.checked)
                setFieldValue(name, selectedOptions)
                let listDays
                if (listWeekDay) {
                  listDays = new Set([
                    ...selectedOptions,
                    ...values.listWeekDay1,
                    ...values.listWeekDay2,
                    ...values.listWeekDay3,
                    ...values.listWeekDay4,
                  ])
                }
                if (listWeekDay1) {
                  listDays = new Set([
                    ...values.listWeekDay,
                    ...selectedOptions,
                    ...values.listWeekDay2,
                    ...values.listWeekDay3,
                    ...values.listWeekDay4,
                  ])
                }
                if (listWeekDay2) {
                  listDays = new Set([
                    ...values.listWeekDay,
                    ...values.listWeekDay1,
                    ...selectedOptions,
                    ...values.listWeekDay3,
                    ...values.listWeekDay4,
                  ])
                }
                if (listWeekDay3) {
                  listDays = new Set([
                    ...values.listWeekDay,
                    ...values.listWeekDay1,
                    ...values.listWeekDay2,
                    ...selectedOptions,
                    ...values.listWeekDay4,
                  ])
                }
                if (listWeekDay4) {
                  listDays = new Set([
                    ...values.listWeekDay,
                    ...values.listWeekDay1,
                    ...values.listWeekDay2,
                    ...values.listWeekDay3,
                    ...selectedOptions,
                  ])
                }
                if (listDays?.size > 0) {
                  listDays = [...listDays]
                  let data

                  listDays.forEach(item => {
                    switch (item) {
                      case 'monday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('1', 'isAvailableOnMonday'),
                        }

                        break
                      case 'tuesday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('2', 'isAvailableOnTuesday'),
                        }

                        break
                      case 'wednesday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('3', 'isAvailableOnWednesday'),
                        }

                        break
                      case 'thursday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('4', 'isAvailableOnThursday'),
                        }

                        break
                      case 'friday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('5', 'isAvailableOnFriday'),
                        }

                        break
                      case 'saturday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('6', 'isAvailableOnSaturday'),
                        }

                        break
                      case 'sunday':
                        data = {
                          ...data,
                          ...setTimeSplitByDay('7', 'isAvailableOnSunday'),
                        }

                        break
                      default:
                        break
                    }
                  })
                  if (!values.isHolidayRepeat) {
                    data = {
                      ...data,
                      ...setTimeSplitByDay('8', 'isAvailableOnHoliday'),
                    }
                  }
                  if (values.splits) {
                    Object.keys(values.splits).forEach(key => {
                      if (!data[key]) {
                        delete values.splits[key]
                      }
                    })
                  }

                  setFieldValue('splits', { ...data, ...values.splits })
                } else {
                  if (!values.isHolidayRepeat) {
                    setFieldValue(
                      'splits',
                      setTimeSplitByDay('8', 'isAvailableOnHoliday')
                    )
                  } else {
                    setFieldValue('splits', {})
                  }
                }
              }}
              checked={values[name].includes(option[valueLabel])}
              // inputId={`${option[valueLabel]}`}
              name={name}
            />
            <label htmlFor={`${option[valueLabel]}`} className='checkbox-label'>
              {option[optionLabel]}
            </label>
          </div>
        ))}
        <div className='alert'>{isTouched && error}</div>
      </div>
    </div>
  )
}

export default CustomCheckBox
